import type { DeepPartial } from '@luna/utils-ts';

import type { Payments } from './Payments';

export const RO: DeepPartial<Payments> = {
    handleLocalErrors: {
        enabled: true,
    },
    useGroupSpecToRenderBadge: {
        enabled: true,
    },
};
